import { apiUrl } from "../utils/constants";
import { GET, POST, PATCH, DELETE } from "./api.service.wrapper";

const normalizeCountyList = (result) => {
  if (Array.isArray(result?.data?.data)) return result.data.data;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result)) return result;
  return [];
};

export const GetCounties = async (options = true) => {
  const params = {};

  if (typeof options === "boolean" || options === null) {
    if (options !== null && options !== undefined) {
      params.is_active = options;
    }
  } else if (typeof options === "object" && options !== null) {
    Object.assign(params, options);
  }

  const response = await GET(apiUrl.county, params);
  return response;
};

export const GetCountyList = async (options = null) => {
  const response = await GetCounties(options);
  return {
    ...response,
    list: normalizeCountyList(response),
  };
};

export const GetCountyById = async (id) => {
  const response = await GET(`${apiUrl.county}/${id}`);
  return response;
};

export const CreateCounty = async (data) => {
  const response = await POST(apiUrl.county, data);
  return response;
};

export const UpdateCounty = async (id, data) => {
  const response = await PATCH(apiUrl.county, id, data);
  return response;
};

export const DeleteCounty = async (id) => {
  const response = await DELETE(apiUrl.county, id);
  return response;
};
